import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui-kit/card';
import { PerformanceDashboard } from '../../types/dashboard.types';

export interface StrengthsImprovementsProps {
  dashboard: PerformanceDashboard;
}

const parseList = (json?: string): string[] => {
  if (!json) return [];
  try {
    return JSON.parse(json) as string[];
  } catch {
    return [];
  }
};

export const StrengthsImprovements = ({ dashboard }: StrengthsImprovementsProps) => {
  const { t } = useTranslation();
  const strengths = parseList(dashboard.StrengthsJson);
  const improvementAreas = parseList(dashboard.ImprovementAreasJson);

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <Card>
        <CardHeader>
          <CardTitle>{t('STRENGTHS')}</CardTitle>
        </CardHeader>
        <CardContent>
          <ul className="list-disc space-y-1 pl-5 text-sm">
            {strengths.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
            {strengths.length === 0 && <p className="text-muted-foreground">{t('NO_DATA')}</p>}
          </ul>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>{t('AREAS_FOR_IMPROVEMENT')}</CardTitle>
        </CardHeader>
        <CardContent>
          <ul className="list-disc space-y-1 pl-5 text-sm">
            {improvementAreas.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
            {improvementAreas.length === 0 && <p className="text-muted-foreground">{t('NO_DATA')}</p>}
          </ul>
        </CardContent>
      </Card>
    </div>
  );
};
